var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHamburgerMenuClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.6146 16.7596L13.855 12L18.6146 7.2404C19.1285 6.72654 19.1285 5.89926 18.6146 5.3854C18.1007 4.87153 17.2735 4.87153 16.7596 5.3854L12 10.145L7.2404 5.3854C6.72654 4.87153 5.89926 4.87153 5.3854 5.3854C4.87153 5.89926 4.87153 6.72654 5.3854 7.2404L10.145 12L5.3854 16.7596C4.87153 17.2735 4.87153 18.1007 5.3854 18.6146C5.89926 19.1285 6.72654 19.1285 7.2404 18.6146L12 13.855L16.7596 18.6146C17.2735 19.1285 18.1007 19.1285 18.6146 18.6146C19.1248 18.1007 19.1248 17.2698 18.6146 16.7596Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHamburgerMenuClose);
export default __webpack_public_path__ + "static/media/hamburger-menu-close.59c623d9d93352be17981a8e0439e4a0.svg";
export { ForwardRef as ReactComponent };